import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { useFormikContext } from 'formik'
import Lottie from 'lottie-react'

// Components
import Form from '@/components/common/Form'
import Button from '@/components/common/Button'
import SuccessIcon from '@/assets/svg/success.svg'

// Lib MISC
import animationData from '@/assets/lotties/recards_loading_send.json'

import styles from './style.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  isSubmitted: PropTypes.bool,
  isSucceeded: PropTypes.bool,
}

function HelpForm ({ isSubmitted, isSucceeded, $t }) {

  const { submitForm } = useFormikContext()

  return (
    <div className={cx('help-form')}>
      {!isSubmitted && (
        <>
          <Form.InputField className={cx('help-form-input')} name='name' type='dark' placeholder={$t.TXT_Help_Form_name_placeholder} />
          <Form.InputField className={cx('help-form-input')} name='email' type='dark' placeholder={$t.TXT_Help_Form_email_placeholder} />
          <Form.InputField className={cx('help-form-input')} name='phone' type='dark' placeholder={$t.TXT_Help_Form_phone_placeholder} />
          <Form.TextareaField
            className={cx('help-form-textarea')}
            wrapperClassName={cx('help-form-textarea-wrapper')}
            name='remark'
            type='dark'
            placeholder={$t.TXT_Help_Form_messages_placeholder}
            size='lg'
          />
          <div className={cx('help-form-submit')}>
            <Button className={cx('help-form-submit-button')} onClick={submitForm}>
              {$t.TXT_Help_Form_submit_button}
            </Button>
          </div>
        </>
      )}
      {isSubmitted && (
        <div className={cx('help-form-success')}>
          {!isSucceeded && <Lottie className={cx('help-form-success-lottie')} animationData={animationData} />}
          {isSucceeded && (
            <>
              <img className={cx('help-form-success-icon')} src={SuccessIcon} />
              <p className={cx('help-form-success-title')}>{$t.TXT_Help_Form_success_title}</p>
              <p className={cx('help-form-success-content')}>{$t.TXT_Help_Form_success_context1}</p>
              <p className={cx('help-form-success-content')}>{$t.TXT_Help_Form_success_context2}</p>
            </>
          )}
        </div>
      )}
    </div>
  )
}

HelpForm.propTypes = propTypes

export default HelpForm
